import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { useMemo } from 'react';
import { sortableGroupDroppableId } from './boardDnd';
import { BoardCard } from './BoardCard';
import type { BoardWorkItemRow } from './types';

export function BoardEpicGroup({
  stage,
  groupKey,
  epicId,
  epicName,
  cards,
  visibleChipKeys,
  parentNameById,
  stages,
  onOpen,
  onParentOpen,
  onChangeStatus
}: {
  stage: string;
  groupKey: string;
  epicId: string | null;
  epicName: string;
  cards: ReadonlyArray<BoardWorkItemRow>;
  visibleChipKeys: ReadonlyArray<string>;
  parentNameById: Map<string, string>;
  stages: ReadonlyArray<string>;
  onOpen: (card: BoardWorkItemRow) => void;
  onParentOpen: (parentId: string) => void;
  onChangeStatus: (cardId: string, nextStatus: string) => void;
}) {
  const { setNodeRef, isOver } = useDroppable({
    id: sortableGroupDroppableId(stage, groupKey)
  });
  const cardIds = useMemo(() => cards.map((c) => c.id), [cards]);

  return (
    <div
      ref={setNodeRef}
      className="work-items-route__board-col-group"
      data-testid={`work-items-route-board-col-${stage}-group-${groupKey}`}
      data-epic-id={epicId ?? ''}
      data-over={isOver}
    >
      {epicId ? (
        <a
          href={`/work-item-detail/${epicId}`}
          className="work-items-route__board-col-group-head"
          onClick={(e) => {
            e.preventDefault();
            onParentOpen(epicId);
          }}
        >
          {epicName}
        </a>
      ) : (
        <span className="work-items-route__board-col-group-head work-items-route__board-col-group-head--muted">
          {epicName}
        </span>
      )}
      <SortableContext items={cardIds} strategy={verticalListSortingStrategy}>
        {cards.map((c) => (
          <BoardCard
            key={c.id}
            card={c}
            visibleChipKeys={visibleChipKeys}
            parentName={
              c.parent_work_item_id
                ? parentNameById.get(c.parent_work_item_id) ?? null
                : null
            }
            stages={stages}
            onOpen={() => onOpen(c)}
            onParentOpen={onParentOpen}
            onChangeStatus={onChangeStatus}
          />
        ))}
      </SortableContext>
    </div>
  );
}
